/**
 * config.js — Konfigurasi terpusat untuk seluruh aplikasi Frontend.
 *
 * Untuk mengganti URL backend (misal saat deploy ke server production),
 * cukup ubah satu nilai di sini, tanpa harus menyentuh file lain.
 */

const API_BASE_URL = "https://api.permatawisata.com";

export default API_BASE_URL;
